<template lang="pug">
v-dialog(
  v-model="dialog"
  width="500"
)
  <template v-slot:activator="{ on, attrs }">
    v-btn(
      color="pink accent-2"
      dark
      v-bind="attrs"
      v-on="on"
    ) 學員分析
  </template>
  v-card
    v-card-title(class="text-h5 grey lighten-2 pa-2") 
      span 學員分析
      v-spacer 
      v-icon(@click="dialog = false") mdi-close
    v-card-text(class="px-4 pt-2 pb-4")
      h4(class="title-1") 參加者分析
      table(class="analyzeTable")
        tr
          th
          th(class="brother") 弟兄
          th(class="sister") 姐妹
          th %
        tr
          td 20～29
          td {{ data.male20to29Count }} 人
          td {{ data.female20to29Count }} 人
          td {{ data.percent20to29 }} %
        tr
          td 30～39
          td {{ data.male30to39Count }} 人
          td {{ data.female30to39Count }} 人
          td {{ data.percent30to39 }} %
        tr
          td 40～49
          td {{ data.male40to49Count }} 人
          td {{ data.female40to49Count }} 人
          td {{ data.percent40to49 }} %
        tr
          td 50+
          td {{ data.male50upCount }} 人
          td {{ data.female50upCount }} 人
          td {{ data.percent50up }} %
        tr
          td(rowspan="3") Total
          td(class="brother") {{ data.maleTotalCount }} 人
          td(class="sister") {{ data.femaleTotalCount }} 人
          td -
        tr
          td(colspan="3") {{ data.totalCount }} 人
      h4(class="title-2") 牧區報名分析
      table(class="analyzeTable")
        tr
          th 學生牧區
          th 社青牧區
          th 家庭牧區
        tr
          td {{ data.youthCount }} 人
          td {{ data.youngAdult }} 人
          td {{ data.menWomen }} 人
        tr
          td {{ data.percentYouth }} %
          td {{ data.percentYoungAdult }} %
          td {{ data.percentMenWomen }} %
      h4(class="title-3") 各堂報名分析
      table(class="analyzeTable")
        tr
          th 江翠
          th 新莊
          th 林口
        tr
          td {{ data.jiangzicuiCount }} 人
          td {{ data.xinzhuangCount }} 人
          td {{ data.linkouCount }} 人
        tr
          td {{ data.percentJiangzicui }} %
          td {{ data.percentXinzhuang }} %
          td {{ data.percentLinkou }} %
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    analyzeData: {
      type: Object
    }
  },
  watch: {
    analyzeData (val) {
      this.data = val
    }
  },
  data: () => ({
    data: {},
    dialog: false
  }),
  methods: {
  }
}
</script>
<style scoped>
.analyzeTable, th, td {
  width: 100%;
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  width: 25%;
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px 10px;
  text-align: center;
}
.brother {
  color: #0091EA;
}
.sister {
  color: #E91E63;
}
.title-1 {
  padding: 4px 10px;
  color: white;
  background: #AD1457
}
.title-2 {
  padding: 4px 10px;
  color: white;
  background: #1976D2
}
.title-3 {
  padding: 4px 10px;
  color: white;
  background: #00796B
}
</style>
